import { render, staticRenderFns } from "./CreditsSuccess.vue?vue&type=template&id=47919666&scoped=true&"
import script from "./CreditsSuccess.vue?vue&type=script&lang=js&"
export * from "./CreditsSuccess.vue?vue&type=script&lang=js&"
import style0 from "./CreditsSuccess.vue?vue&type=style&index=0&id=47919666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47919666",
  null
  
)

export default component.exports